export type WorkspaceAgentComposerPlainTextNode = {
  type: 'paragraph';
  content: Array<{ type: 'text'; text: string }>;
};

/**
 * TipTap's string `insertContent` and HTML clipboard parse go through a DOM parser, which collapses
 * `\n` inside a single tag. The wire serializer only emits a break for a `paragraph` or `hardBreak`
 * node, so pasted or seeded prompts have to become those nodes or the agent never sees the lines.
 */
export const buildWorkspaceAgentComposerPlainTextContent = (value: string): WorkspaceAgentComposerPlainTextNode[] =>
  value.split(/\r?\n/).map((line) => ({
    content: line ? [{ type: 'text', text: line }] : [],
    type: 'paragraph',
  }));
